import { autoinject, transient } from "aurelia-framework";
import { UserSecurityInfoModel } from "../../../../../models/authentication/token.models";
import { VesselDetailModel } from "../../../../../models/vessels/vessel.models";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { ManageRightShipUsersClientService } from "../../../../../services/modules/righship-qi-manage-users.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
export class ReportADataIssueDialog {

    isAppEnvironmentStaging: boolean;
    vessel: VesselDetailModel;
    user: UserSecurityInfoModel;
    name: string;
    surname: string;
    businessUnit: string;

    constructor(private dialogClientService: DialogClientService, private userClientService: UserClientService,
        private manageRightShipUsersClientService: ManageRightShipUsersClientService, private configService: ConfigService) {
        this.user = userClientService.currentUser;
        this.name = this.userClientService.currentUser.userName.split(' ', 1).toString();
        this.surname = this.userClientService.currentUser.userName.substr(this.userClientService.currentUser.userName.indexOf(' ', 1) + 1);
        this.manageRightShipUsersClientService.getBusinessUnitUser(this.userClientService.currentUser.id)
            .then(x => {
                this.businessUnit = x.businessUnit ? x.businessUnit.name : null;
            });
        this.isAppEnvironmentStaging = this.configService.config.environment.toLowerCase() == "staging";
    }

    activate(model: VesselDetailModel) {
        this.vessel = model;
    }

    attached() {
        window.addEventListener('message', (event) => {
            if (event.origin != 'https://form.typeform.com')
                throw new Error("Origin not allowed")

            if (event.data.type == "form-submit") {
                this.onCancel();
            }
        }, true);
    }

    onCancel = () => {
        setTimeout(() => {
            this.cancel();
        }, 60000);
    }

    cancel() {
        this.dialogClientService.hide();
    }
}